module.exports = __webpack_public_path__ + "static/media/analise_mercado_livrarias.bb4e9540.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/analise_mercado_livrarias.svg
// module id = 1302
// module chunks = 0